import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { PageLevelNotification } from '@americanexpress/dls-react';
import { Link } from '@americanexpress/one-app-router';
import { getOneCmsLoungeFinderImagesBaseUrl } from '@/selectors/oneCmsSelectors';
import { IconChevronRight } from '@/components/icons';
import {
  getCardArtUrl,
  getBasePathFromLocation,
  formatText,
} from '@/helpers/utils';
import { cardArtMapping } from '@/constants/productMapping';
import { useCommonContent } from '@/hooks/oneCmsIntlHooks/oneCmsIntlHelperHooks';
import DividerWithMessage from './DividerWithMessage';

const Wallet = ({ wallet, handleClick }) => {
  const baseOneCmsImgUrl = useSelector(getOneCmsLoungeFinderImagesBaseUrl);
  const { selectCard, productDisplayNames } = useCommonContent();

  if (wallet.length === 0) {
    return (
      <>
        <PageLevelNotification
          isDismissible={false}
          type="caution"
          className="tw-mb-6"
        >
          <p className="tw-text-base">{selectCard?.noLoungeBenefit}</p>
        </PageLevelNotification>
        <hr className="tw-mb-6 tw-border-gray-300" />
      </>
    );
  }

  return (
    <div className="tw-mb-6">
      <p
        htmlFor="country-select"
        className="tw-mb-2 tw-inline tw-font-sans tw-text-base tw-font-bold tw-text-gray-700"
      >
        {selectCard?.selectLabel_loggedIn}
      </p>
      <div className="tw-mb-6 tw-flex tw-flex-col">
        {wallet.map((product) => {
          const locale = product?.locale?.toLowerCase();
          const productName = product?.loungeFinderProduct;
          const displayName =
            productDisplayNames[productName]?.selectCardDisplayName;
          const lastDigits = product?.displayAccountNumber;
          const imgSrc = getCardArtUrl({
            baseOneCmsImgUrl,
            product: cardArtMapping[productName],
            locale,
          });
          const basePath = getBasePathFromLocation(
            locale,
            window.location.pathname
          );
          return (
            <Link
              key={productName}
              to={{
                pathname: `${basePath}/${productName}`,
                search: window.location.search,
              }}
              className="tw-flex tw-items-center tw-gap-4 tw-px-2 tw-py-4 hover_tw-rounded-lg hover_tw-bg-gray-200"
              onClick={(e) => handleClick(e, productName)}
            >
              <img
                src={imgSrc}
                alt="card-art"
                className="tw-h-11 tw-w-17dot5"
              />
              <div className="tw-flex tw-flex-col">
                <p className="tw-text-gray-800">{displayName}</p>
                <p className="tw-text-sm tw-text-gray-600">
                  {formatText(selectCard?.accountNumber, { lastDigits })}
                </p>
              </div>
              <IconChevronRight
                size="sm"
                className="tw-ml-auto tw-fill-gray-600"
              />
            </Link>
          );
        })}
      </div>
      <DividerWithMessage message={selectCard?.divider} />
    </div>
  );
};

Wallet.propTypes = {
  wallet: PropTypes.arrayOf({}).isRequired,
  handleClick: PropTypes.func.isRequired,
};

export default Wallet;
